import { Hero } from "@/components/landing/Hero";
import { TrustBar, HowItWorks, Pricing, About, Faq } from "@/components/landing/Sections";
import { SiteFooter } from "@/components/landing/SiteFooter";
import { usePublicSettings } from "@/hooks/usePublicSettings";

export default function Landing() {
  const s = usePublicSettings();
  return (
    <main data-testid="landing-page">
      <Hero settings={s} />
      <TrustBar s={s} />
      <HowItWorks />
      <Pricing s={s} />
      <About s={s} />
      <Faq />
      <section className="py-20 text-center px-5">
        <h2 className="font-serif text-3xl sm:text-4xl text-navy">Bastano 60 secondi per saperlo</h2>
        <a href="#verifica" data-testid="bottom-cta-verify" className="inline-block mt-6 px-8 py-3 rounded-full bg-gold text-navy font-semibold hover:bg-gold-dark transition-colors">Verifica gratis ora</a>
      </section>
      <SiteFooter s={s} />
    </main>
  );
}
